import React, { Fragment, useState } from "react";
import { Table } from "react-bootstrap";


const GenerateTimeCard = (props) => {

    const [isIndex, setIsIndex] = useState(null);
    const [data, setData] = useState(null);

    const handleDoubleClick = (index, isval) => {
        setIsIndex(index);
        props?.editHandler(isval)
    }

    const onChangeHandler = (value, index, childIndex) => {
        const updatedData = { ...data };
        const time = value ? parseInt(value, 10) : 0; // Parse input as integer

        // Update the specific working hour
        updatedData.data_table[index].time_details[childIndex].working_hour = time;

        // Calculate total hours for the current row
        const totalRowHours = updatedData.data_table[index].time_details.reduce(
            (acc, element) => acc + element.working_hour,
            0
        );
        updatedData.data_table[index].total_hour = totalRowHours;

        // Calculate the overall total hours
        const overallTotalHours = updatedData.data_table.reduce(
            (acc, row) => acc + row.total_hour,
            0
        );
        updatedData.total_hour = overallTotalHours;

        // Calculate the total pay based on employee rate and total hours
        // const overallTotalPay = updatedData.total_hour * (updatedData.emp_rate || 0);
        // updatedData.total_pay = overallTotalPay;

        // Update the state with the modified data
        setData(updatedData);
    };

    const onChangeRateHandler = (value) => {
        const updatedData = { ...data }; // Create a shallow copy of data
        const rate = value ? parseInt(value, 10) : 0;
        updatedData.emp_rate = rate;
        // Calculate the total pay based on employee rate and total hours
        // const overallTotalPay = updatedData.total_hour * (updatedData.emp_rate || 0);
        // updatedData.total_pay = overallTotalPay;
        setData(updatedData);
    }

    return (
        <Fragment>
            <Table className='cart-table table-bordered mb-3'>
                <thead>
                    <tr className='cart-table-header'>
                        <th colSpan={3}>
                            <h4 className='timeSheet-project-title'>{props?.projectName}</h4>
                        </th>
                        <th>
                            <strong>Sun</strong>
                        </th>
                        <th>
                            <strong>Mon</strong>
                        </th>
                        <th>
                            <strong>Tue</strong>
                        </th>
                        <th>
                            <strong>Wed</strong>
                        </th>
                        <th>
                            <strong>Thr</strong>
                        </th>
                        <th>
                            <strong>Fri</strong>
                        </th>
                        {/* {props.details?.time_table?.length > 5 ?
                            <th>
                                <strong>Sat</strong>
                            </th> : null} */}
                        <th>
                            <strong>Sat</strong>
                        </th>
                        <th className='text-center'>
                            <strong>Total Hrs</strong>
                        </th>

                    </tr>
                </thead>

                {
                    props?.details?.weeks_table?.map((element, zIndex) => {
                        return (
                            <>
                                <thead>
                                    <tr className='cart-table-header'>
                                        <th>
                                            <strong>Project</strong>
                                        </th>

                                        <th>
                                            <strong>Activity</strong>
                                        </th>
                                        <th>
                                            <strong>Task</strong>
                                        </th>
                                        {
                                            element?.time_table?.length > 0 &&
                                            element.time_table.slice(0, 7).map((dates, dateIndex) => (
                                                <th key={dateIndex}>
                                                    <strong>{dates.date}</strong>
                                                </th>
                                            ))
                                        }
                                        <th className="text-center">
                                            {props.isEdit && (
                                                props.isEditShow && isIndex === zIndex ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning btn-xs"
                                                        onClick={() => handleDoubleClick(zIndex, false)}
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning btn-xs"
                                                        onClick={() => handleDoubleClick(zIndex, true)}
                                                    >
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>
                                                )
                                            )}
                                        </th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        element?.data_table?.length > 0 ? (element?.data_table?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.project_id}</td>
                                                    <td>{item.activity_id}</td>
                                                    <td>{item.task_id}</td>
                                                    {item.time_details?.slice(0, 7).map((times, timesIndex, arr) => (
                                                        <td
                                                            className={`${times?.holiday ? "disable-column" : ""}`}
                                                            key={timesIndex}
                                                        >
                                                            {(timesIndex === 0 || timesIndex === arr.length - 1) ? (
                                                                ''
                                                            ) : (
                                                                props?.isEditShow && isIndex === zIndex ? (
                                                                    times?.holiday ? (
                                                                        '0'
                                                                    ) : (
                                                                        <input
                                                                            className="timeEditable-control"
                                                                            onChange={(e) => props.changeHandler(e.target.value, zIndex, index, timesIndex)}
                                                                            value={times.working_hour}
                                                                        />
                                                                    )
                                                                ) : (
                                                                    times?.holiday ? (
                                                                        '0'
                                                                    ) : (
                                                                        props.isLink && times.working_hour > 0 ? (
                                                                            <button
                                                                                className="time-link"
                                                                                onClick={() => props.getTimeDetails(zIndex, timesIndex, item.task_id)}
                                                                            >
                                                                                {times.working_hour}
                                                                            </button>
                                                                        ) : (
                                                                            times.working_hour
                                                                        )
                                                                    )
                                                                )
                                                            )}
                                                        </td>
                                                    ))}

                                                    <td className='total-hrs'>{item.total_hour}</td>

                                                </tr>
                                            );
                                        })
                                        ) : (<tr className="table-row-nodata">
                                            <td colSpan={12} className="text-center">No data available</td>
                                        </tr>
                                        )}

                                </tbody>
                            </>);
                    })
                }
                <tbody>
                    <tr className='total-time'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colSpan={2}><strong>TOTAL HOURS :</strong></td>
                        <td className='total-hrs'><strong>{props.details?.total_hour}</strong></td>
                    </tr>
                    {/* <tr className='total-time'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colSpan={2}><strong>TOTAL LEAVE :</strong></td>
                        <td className='total-hrs'><strong>{props.details?.total_leave}</strong></td>
                    </tr> */}
                </tbody>
            </Table>
        </Fragment>
    )
}

export default GenerateTimeCard;